// extracted by css-extract-rspack-plugin
export default {"field":"VisibilityValue-module__field__tfUIJ","label":"VisibilityValue-module__label__vKozY","value":"VisibilityValue-module__value__oO_1R"};